const config = {
  authTokenKey: 'authToken',
  apiUrl: 'https://budget-tracker.alextotheroh.com:3000'
}

export default config;